export function validateEmail(email) {
  if (!email) return 'Email is required';
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(email)) return 'Please enter a valid email';
  return null;
}

export function validateUsername(username) {
  if (!username) return 'Username is required';
  if (username.length < 3) return 'Username must be at least 3 characters';
  if (username.length > 20) return 'Username must be at most 20 characters';
  if (!/^[a-z0-9_]+$/.test(username)) {
    return 'Use only lowercase letters, numbers and underscores';
  }
  return null;
}

export function validatePassword(password) {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  return null;
}

export function validateMeasurement(value) {
  if (value === '' || value === undefined || value === null) return null;
  const num = parseFloat(value);
  if (isNaN(num)) return 'Must be a number';
  if (num < 10 || num > 300) return 'Must be between 10 and 300 cm';
  return null;
}
